<template>
  <Dropdown ref="dropdown" :link="false" disable-toggle-on-click-inside>
    <template #button="{ open }">
      <button ref="referenceElm" class="btn btn-brand" @click="open">
        <span>Period</span>
      </button>
    </template>
    <template>
      <DropdownList>
        <DropdownListItem>
          <div class="py-4">
            <DateRangePicker @created="handleChange" @apply="handleChange" />
          </div>
        </DropdownListItem>
      </DropdownList>
    </template>
  </Dropdown>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker.vue';

export default {
  name: 'DropdownDateRangePicker',
  components: {
    DateRangePicker,
  },
  methods: {
    handleChange(period) {
      this.$emit('changed', period);
      if (this.$refs.dropdown && this.$refs.dropdown.showPopper) {
        this.$refs.dropdown.showPopper = false;
      }
    },
  },
};
</script>
